import { render, staticRenderFns } from "./SNS.vue?vue&type=template&id=8aca20ba&scoped=true&"
import script from "./SNS.vue?vue&type=script&lang=js&"
export * from "./SNS.vue?vue&type=script&lang=js&"
import style0 from "./SNS.vue?vue&type=style&index=0&id=8aca20ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aca20ba",
  null
  
)

export default component.exports